import { z } from 'zod';
const loginSchema = z.object({
    email: z.string().email('Invalid email format'),
    password: z.string().min(6, 'Password must be at least 6 characters')
});
const loginTotpSchema = z.object({
    tempToken: z.string().min(1, 'Temporary token is required'),
    totpCode: z.string().regex(/^[\dA-Z]{6,8}$/, 'Code must be 6-8 characters (digits or uppercase letters)')
});
const verifyTokenSchema = z.object({
    token: z.string().min(1, 'Token is required')
});
const totpVerifySchema = z.object({
    setupToken: z.string().min(1, 'Setup token is required'),
    code: z.string().regex(/^\d{6}$/, 'Code must be 6 digits')
});
// Validation schema
const regenerateBackupSchema = z.object({
    password: z.string().min(6, 'Password must be at least 6 characters')
});
const totpSetupSchema = z.object({
    setupToken: z.string().min(1, 'Setup token is required')
});
const totpSetupResponseSchema = z.object({
    secret: z.string().describe('Chiave segreta TOTP per l\'utente'),
    qr_code_data_url: z.string().describe('QR code come data URL (data:image/png;base64,...)'),
    backup_codes: z.array(z.string()).describe('Array di codici backup monouso'),
    message: z.string().optional().describe('Messaggio informativo')
});
export { loginSchema, loginTotpSchema, verifyTokenSchema, totpVerifySchema, regenerateBackupSchema, totpSetupSchema, totpSetupResponseSchema };
//# sourceMappingURL=loginSchemas.js.map